export default __webpack_public_path__ + "991c8c3852a24188e3e23849ae0998bd.svg";